module.exports = __webpack_public_path__ + "img/tzc.f5077a51.png";